import {svgIconWrapper} from '../svg-icon-wrapper';

import GravityFormsRegular from './gravity-forms-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <GravityFormsRegular {...rest} />;
}

SvgComponent.iconName = 'gravityFormsRegular';

export const GravityFormsRegularIcon = svgIconWrapper(SvgComponent);
